import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../hooks/useAuth';
import { useFirebase } from '../../../hooks/useFirebase';
import { queryGet } from '../../tools/tools';

export const useOrderSearch = (orderNumber) => {
  const { user } = useAuth();
  const { remoteConfig } = useFirebase();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['sales-order-search', orderNumber],
    queryFn: () =>
      queryGet(
        remoteConfig,
        `/order/search?orderNumber=${encodeURIComponent(orderNumber ?? '')}`,
        user?.accessToken
      ),
    enabled: !!user?.accessToken && !!remoteConfig
  });

  return {
    data: data ?? [],
    loading: isLoading,
    error: isError
  };
};
